import * as React from 'react';
import BOM from "@system/config/bom";
import useReduxState from 'src/hooks/useReduxState';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import { useBOMStore } from 'src/hooks/bom';
import System from 'src/helper/system';
import SystemAlerts from 'src/component/SystemAlerts';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { SET_bomUploadFile__progress_percentage } from 'src/store/slice/model/BOM';
import { useState } from 'react';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';
import Helper from 'src/support/Helper';
import Constants from "src/support/Constants";

const StartBom = (props) => {

    const [{ bomUploadFile__progress_percentage }, { bom_upload_file }, { download_bom_template, bom_upload_progress }] = useBOMStore();
    const [type, setType] = useReduxState("upload_file", 'setType');
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
    //DT - 24/8/23 - US 12938: Prod - Getting system error when uploading BOM file (Too many data with comma separated
    const [errorMsgs, setErrorMsgs] = useState([]);
    const { sourceOfBOM } = Constants;
    const typeHandler = (type) => {
        setType(type);
    };

    const downloadBomTemplate = async () => {
        await download_bom_template()
    }

    const fileUpload = async (files, event) => {
        let file = files[0];
        store.dispatch(SET_bomUploadFile__progress_percentage({
            percentage: 0.1
        }))
        let file_upload = await bom_upload_file({ file, source: sourceOfBOM.UPLOAD })
        file_upload = file_upload.payload;
        console.log(file_upload)
        if (file_upload.isSuccessFull === true && file_upload.data !== undefined && file_upload.data !== null) {
            setErrorMsgs([])
            try {
                if (file_upload.data.errorMessage && JSON.parse(file_upload.data.errorMessage).length > 0 && JSON.parse(file_upload.data.errorMessage)[0]) {
                    // localStorage.setItem('flash_message', JSON.parse(file_upload.data.errorMessage)[0].Message);
                }

            } catch (e) { }
            try {
                localStorage.setItem('uploaded_file', true);
            } catch (e) { }
            let _bomId = file_upload.data !== undefined && file_upload.data !== null && file_upload.data.bomId !== undefined && file_upload.data.bomId !== null && file_upload.data.bomId.trim() !== '' ? file_upload.data.bomId : '';

            if (_bomId !== '') {
                localStorage.setItem("adobeEventType","bomFileUpload");
                if (file_upload.errorCode !== undefined && file_upload.errorCode === 'BOM001') {
                    window.location.href = BOM.getBomRematchRouteURL({ bomId: _bomId });
                } else {
                    await progressBarCalculation(_bomId)
                }
            }
        } else {
            store.dispatch(SET_bomUploadFile__progress_percentage({
                percentage: 0
            }))
            if (file_upload.errorMessage) {
                const errMsges = JSON.parse(file_upload.errorMessage);
                setErrorMsgs(errMsges)
            }
        }
        //This will reset file input
        event.target.value = null;
    }

    const progressBarCalculation = async (bomId) => {
        let res = await bom_upload_progress({ bomId: bomId });
        let progressStatus = parseInt(parseInt(res.totalProcessed * 100.0) / parseInt(res.totalMatches));
        if (progressStatus >= 100) {
            store.dispatch(SET_bomUploadFile__progress_percentage({
                percentage: 100
            }))
            //by Ramya Kannan (Bom Upload - Adobe script)
            //  localStorage.setItem("adobeEventType","bomFileUpload");
            window.location.href = BOM.getBomDetailByIdRouteURL(
                bomId,
                {
                    go: System.getParams().go,
                    isReRunPartMatch: false
                }
            );
            return
        }
        let per = progressStatus > 0 ? progressStatus : 0.1;
        store.dispatch(SET_bomUploadFile__progress_percentage({
            percentage: per
        }))
        // call doSomething again
        setTimeout(() => {
            progressBarCalculation(bomId);
        }, 1200);

    }

    // drag state
    const [dragActive, setDragActive] = React.useState(false);
    // ref
    const inputRef = React.useRef(null);

    // handle drag events
    const handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    // triggers when file is dropped
    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFile(e.dataTransfer.files, e);
        }
    };

    // triggers when file is selected with click
    const handleChange = function (e) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            handleFile(e.target.files, e);
        }
    };

    // triggers the input when the button is clicked
    const onButtonClick = () => {
        inputRef.current.click();
    };

    const handleFile = async (files, e) => {
        await fileUpload(files, e);
    };

    return (
        <>
            <div className="select-bom">
                {errorMsgs.length > 0 &&
                    errorMsgs.map((v, i) => (
                        <AlertContentWithFlag key={Helper.UUID()} message={v.Message} type="danger" isDisplay={true} isDisplayIcon={false} />
                    ))
                }
                <div className="d-flex justify-content-between align-items-stretch">
                    <div className="select-bom-left">
                        <h1 className="m-b-20 mt-0">Start a BOM</h1>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="type"
                                checked={type === "upload_file"} id="upload_file" value="upload_file"
                                onChange={(e) => typeHandler(e.target.value)} />
                            <label className="form-check-label mt-0 m-b-15" htmlFor="upload_file">
                                Upload File
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="type"
                                checked={type === "bom_template"} id="bom_template" value="bom_template"
                                onChange={(e) => typeHandler(e.target.value)} />
                            <label className="form-check-label mt-0 m-b-15" htmlFor="bom_template">
                                BOM Template
                            </label>

                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="type"
                                checked={type === "create_parts_list"} id="create_parts_list"
                                value="create_parts_list"
                                onChange={(e) => typeHandler(e.target.value)} />
                            <label className="form-check-label mt-0 m-b-15" htmlFor="create_parts_list">
                                Create Parts List
                            </label>
                        </div>
                        <div className="form-check mb-0">
                            <input className="form-check-input" type="radio" name="type" checked={type === "find_part"}
                                id="find_part" value="find_part"
                                onChange={(e) => typeHandler(e.target.value)} />
                            <label className="form-check-label mt-0 m-b-0" htmlFor="find_part">
                                Find a Part
                            </label>
                        </div>
                    </div>
                    <div className="select-bom-right bom_file_upload">
                        {type === "upload_file" &&
                            <>
                                <form id="label-file-upload" htmlFor="input-file-upload"
                                    className={dragActive ? "bom-file-upload drag-active" : "bom-file-upload"}
                                    onDragEnter={handleDrag}
                                    onSubmit={(e) => e.preventDefault()}>
                                    {bomUploadFile__progress_percentage < 0.1 && //13998
                                        <>
                                            {latest_system_notification_data.errorModule !== undefined && latest_system_notification_data.errorModule === 'bomUpload' &&
                                                <SystemAlerts />
                                            }
                                            <input ref={inputRef} type="file" id="input-file-upload" multiple={false}
                                                style={{ display: 'none' }}
                                                onChange={handleChange} />
                                            <h4 className="font-18">Drag your BOM file here to upload
                                                <div className="or-text">or</div>
                                            </h4>
                                            <button className="btn bs5 btn-primary upload-button w160" onClick={onButtonClick}>select a file
                                            </button>
                                            <div className="font-bold font-16 mt-2 mb-1">
                                                Maximum file size 20MB, 10 columns and 1000 lines. File types accepted xls, xlsx,csv, tab, txt.
                                            </div>
                                            <div className="font-bold font-16 mt-2 mb-1">
                                                Please ensure that the first row in your upload files is column headers.
                                            </div>
                                        </>
                                    }
                                    {/* DT - 23/8/23 - Bug 13363: While uploading BOM file then progress bar is starting after receiving response from BomUpload API */}
                                    {bomUploadFile__progress_percentage > 0 && bomUploadFile__progress_percentage < 100 &&
                                        <div>
                                            <div className="progress-bar-container" id="bomUploadProgress">
                                                <div className="progress-bar" id="bomUploadBar"
                                                    style={{ width: bomUploadFile__progress_percentage + "%" }} />
                                            </div>
                                            <p>
                                                Maximum file size 20MB, 10 columns and 1000 lines. File types accepted xls, xlsx, csv, tab, txt.
                                            </p>
                                            <div>
                                                Please ensure that the first row in your upload files is column headers.
                                            </div>
                                        </div>
                                    }
                                </form>
                                {dragActive && <div id="drag-file-element"
                                    onDragEnter={handleDrag} onDragLeave={handleDrag}
                                    onDragOver={handleDrag} onDrop={handleDrop} />}
                            </>
                        }

                        {type === "bom_template" && <div className="bom-file-upload">
                            <h4 className="font-18 m-b-15">The BOM template will help eliminate errors </h4>
                            <button className="btn bs5 btn-primary w160"
                                onClick={() => downloadBomTemplate()}>DOWNLOAD TEMPLATE
                            </button>
                        </div>}

                        {type === "create_parts_list" && <div className="bom-file-upload">
                            <h4 className="font-18 m-b-15">Copy/Paste or create multiple parts list</h4>
                            <button className="btn bs5 btn-primary w130" data-toggle="modal" data-target="#add-parts"
                                onClick={() => {
                                    store.dispatch(system_notification({
                                        name: 'CreatePartPopup',
                                        data: {
                                            title: "Create parts list",
                                            addFrom: "AddPart"
                                        },
                                    }));
                                }}>Add parts
                            </button>
                        </div>}

                        {type === "find_part" && <div className="bom-file-upload">
                            <h4 className="font-18 m-b-15">Find and add a part to your BOM</h4>
                            <button className="btn bs5 btn-primary w130" data-toggle="modal" data-target="#find-parts"
                                onClick={() => {
                                    store.dispatch(system_notification({
                                        name: 'FindPartPopup',
                                        data: {
                                            addFrom: "FindPart"
                                        },
                                    }));
                                }}>Find Part
                            </button>
                        </div>}
                    </div>
                </div>
            </div>
        </>
    );
}

export default StartBom;